// extracted by mini-css-extract-plugin
export default {"BuildingListItem":"BuildingView_BuildingListItem__2dXzx"};